module.exports = __webpack_public_path__ + "2e831e62d7f75829309741de0cf3712e.png";